import { remove } from "../index";

// DELETE /ideas/:id — server takes the id from the URL, no body needed.
// Pass the bare id string from the modal (mirrors how the delete-post
// API works for posts, except posts go through a body field).
export const deleteIdea = (ideaId) => {
  return remove(`/ideas/${ideaId}`, {});
};
